import { ref, watch, toRef } from 'vue';
import { cloneDeep, get, isEqual } from 'lodash-es';

function normalizeParams(params, values) {
  const result = {};
  const reactiveKeys = [];
  Object.keys(params).forEach(key => {
    let value = params[key];
    const isReactiveKey = key[0] === '$';
    if (isReactiveKey) {
      reactiveKeys.push(key);
      value = values[key];
    }
    result[key] = value;
  });

  return {
    reactiveKeys,
    result,
  };
}

/**
 * 让组件支持通过ajax获取远程数据，并分析参数中是否有动态参数（其他表单值），如果有则watch该动态参数是否有变动，有则再次请求接口
 */
export default (props, callback) => {
  const lastParams = ref({});
  const reactiveKeys = ref([]);
  const values = toRef(props, 'values');
  const disabled = toRef(props, 'disabled');
  const loading = ref(false);

  const getFromRemote = () => {
    if (props.config.remoteApi) {
      // disabled的时候是否请求接口，默认允许
      const disabledFetchable =
        'disabledFetchable' in props.config.remoteApi ? props.config.remoteApi.disabledFetchable : true;

      if (disabledFetchable || (!disabledFetchable && !disabled.value)) {
        const { api, params } = props.config.remoteApi;
        const $params = normalizeParams(params, props.values);
        reactiveKeys.value = $params.reactiveKeys;
        const equal = isEqual($params.result, lastParams.value);

        // 相等且有参数的时候，return
        if (equal && Object.keys($params.result).length !== 0) return;

        loading.value = true;
        api($params.result)
          .then(res => {
            loading.value = false;
            return res;
          })
          .then(callback)
          .catch(() => {
            loading.value = false;
          });
        lastParams.value = $params.result;
      }
    }
  };

  watch(disabled, getFromRemote, { immediate: true });

  watch(
    () => cloneDeep(values),
    (nv, ov) => {
      if (reactiveKeys.value.length) {
        const idx = reactiveKeys.value.findIndex(i => {
          // console.log('get', get(nv.value, i), get(ov.value, i));
          return get(nv.value, i) !== get(ov.value, i);
        });
        // console.log(111111, { reactiveKeys, nv, ov, idx });
        if (idx > -1) {
          props.handleChange(undefined);
          getFromRemote();
        }
      }
    },
    { deep: true }
  );

  return {
    loading,
  };
};
